import LBox, { LBoxProps } from "@components/LBox";
import { ReactNode } from "react";

export type ContentProps = LBoxProps & {
  children: ReactNode;
};

const Content = ({ children, ...rest }: ContentProps) => {
  return <LBox {...rest}>{children}</LBox>;
};

export default Content;
